module.exports = __webpack_public_path__ + "img/Chart.7935d22c.svg";